// Helpers pour formatter / valider les valeurs retournées par l'IA
// Extracted from SyntheseMarchesPage.js for reusability and testability.

// Formats any value (string, number, object, nested array) into displayable text
export const formatValue = (value) => {
  if (value === null || value === undefined) return null;
  if (typeof value === 'string') return value;
  if (typeof value === 'number') return String(value);
  if (typeof value === 'object') {
    if (Array.isArray(value)) {
      return value
        .map((item) => {
          if (typeof item === 'string') return item;
          if (typeof item === 'object') {
            return Object.entries(item)
              .filter(([, v]) => v && v !== 'Non précisé' && v !== null)
              .map(([, v]) => (typeof v === 'object' ? formatValue(v) : `${v}`))
              .join(', ');
          }
          return String(item);
        })
        .filter(Boolean)
        .join('\n');
    }

    // Single-key object → return just the value
    const entries = Object.entries(value).filter(
      ([, v]) => v && v !== 'Non précisé' && v !== null
    );
    if (entries.length === 1) {
      const [, val] = entries[0];
      if (typeof val === 'string' || typeof val === 'number') {
        return String(val);
      }
    }

    return entries
      .map(([k, v]) => {
        const label = k.replace(/_/g, ' ').replace(/([A-Z])/g, ' $1').trim();
        if (typeof v === 'object') return formatValue(v);
        return `${label}: ${v}`;
      })
      .join('\n');
  }
  return String(value);
};

// Returns true if the value is meaningful (non-empty, not "Non précisé", etc.)
export const hasValue = (value) => {
  if (!value) return false;
  if (typeof value === 'string') {
    const lower = value.toLowerCase().trim();
    return (
      lower !== '' &&
      !lower.includes('non précisé') &&
      !lower.includes('non spécifié') &&
      !lower.includes('non mentionné') &&
      !lower.includes('non renseigné') &&
      lower !== 'n/a' &&
      lower !== 'na'
    );
  }
  if (typeof value === 'object') {
    if (Array.isArray(value)) return value.length > 0 && value.some((v) => hasValue(v));
    return Object.values(value).some((v) => hasValue(v));
  }
  return true;
};
